import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CareItem } from 'src/replicant/buruburu/care/care.ruleset';

export type CareActionType =
  | 'food'
  | 'snack'
  | 'toy'
  | 'firstAid'
  | 'bath'
  | 'toilet'
  | 'evolve'
  | 'ascension';

type CareAction = {
  type: CareActionType;
  item?: CareItem['id'];
};

const initialState = {
  currentCareAction: null as CareAction | null,
};

const { actions, reducer } = createSlice({
  name: 'care',

  initialState,

  reducers: {
    setCareAction(care, { payload }: PayloadAction<CareAction>) {
      care.currentCareAction = payload;
    },
  },

  extraReducers: {
    RESET_APP: () => initialState,
  },
});

export const careActions = actions;
export default reducer;
